import { makeAutoObservable } from 'mobx'

import { ShopRootStore } from 'shop/stores/shopRoot.store'
import { STIPE_ELEMENT_OPTIONS_DEFAULT } from 'constants/paymentSettingShared.constants'
import type { StripeElementsOptionsMode } from '@stripe/stripe-js'

import {
  StripeElementsPayloads,
  StripePaymentElement,
} from '../../interfaces/payment-method-interfaces/StripePaymentMethod'

export class ShopP24PaymentMethodStore implements StripePaymentElement {
  storeName = 'ShopP24PaymentMethodStore'
  root: ShopRootStore = null

  constructor(root: ShopRootStore) {
    this.root = root

    makeAutoObservable(this)
  }

  getStripeElementPayload = ({
    isDealsPage,
    isManagePage,
  }: {
    isDealsPage: boolean
    isManagePage: boolean
  }): StripeElementsOptionsMode => {
    let store: StripeElementsPayloads = null

    if (isDealsPage) {
      store = this.root.dealsStore
    } else if (isManagePage) {
      store = this.root.ordersStore
    } else {
      store = this.root.paymentStore
    }

    return (store?.getP24StripeElementPayload && store.getP24StripeElementPayload()) || STIPE_ELEMENT_OPTIONS_DEFAULT
  }

  getPaymentElementOptions = () => ({
    fields: {
      billingDetails: 'never',
    },
  })
}
